import TabPage from "./../factories/tab-page";
import "./../components/view-models/bao-color-picker";
import "./../bindings/bao-number-box";
import BaseViewModelModule from "./../factories/base-view-model2";
import * as ko from "knockout";
import Bao from "./../services/bao-service";
import TabController from "./../factories/tab-controller";
import BaoDialog from "./../factories/bao-dialog";
class ShiftType extends BaseViewModelModule {
    ShiftTypeColors: KnockoutObservableArray<string> = ko.observableArray([]);
    IsAllowForAutomaticSwapProposal: KnockoutObservable<boolean>;
    IsVarioShift: KnockoutObservable<boolean>;
    Name: KnockoutObservable<string>;
    SwapPriority: KnockoutObservable<string>;
    StartTime: KnockoutObservable<string>;
    Duration: KnockoutObservable<string>;
    DurationHtml: KnockoutObservable<string>;
    DurationHours: KnockoutObservable<number> = ko.observable(0);
    DurationMinutes: KnockoutObservable<number> = ko.observable(0);
    DurationMinutesEnabled: KnockoutObservable<boolean> = ko.observable(true);
    IsFreeShift: KnockoutObservable<boolean> = ko.observable(false);
    constructor(tabPage: TabPage) {
        super(tabPage);
    }
    //ConfigurationItemTypeTab: Factories.TabPage;
    //ConfigurationItemTypeTabTitle = ko.observable<string>();     
    //TabController = new TabController(false);
    CompleteCheck() {
        var isComplete: boolean = true;

        if (typeof this.Name() === "undefined" || this.Name() === "" || this.Name() === null) {
            isComplete = false;
        }
        if (this.IsAllowForAutomaticSwapProposal()) {
            if (typeof this.SwapPriority() === "undefined" || this.SwapPriority() === "" || this.SwapPriority() === null) {
                isComplete = false;
            }
        }

        // Validation StartTime
        let starttime = this.StartTime();
        // Validate only for non-free shifts
        if (!this.IsFreeShift()) {
            // Convert duration to minutes
            let duration = (this.DurationHours() * 60 + +this.DurationMinutes());
            this.Duration(duration.toString());

            var starttimeValid = new RegExp("^(([0-1]?[0-9])|([2][0-3]))[:][0-5][0-9]$");
            if (!starttime || !(starttime.match(starttimeValid))) {
                new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgShiftTypeValidationStartTimeInvalid"), "info");
                return false;
            }
            if (duration <= 0 || duration > 1440) {
                new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgShiftTypeValidationDurationInvalid"), "info");
                return false;
            }
        }

        if (!isComplete) {
            new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
        }
        return isComplete;
    }
    InitUrl() {
        return "ShiftType/Init";
    }
    loadShiftColors() {
        return Bao.post("ShiftType/GetShiftTypeColors")
            .then(result => {
                //ko.map.fromJS(result, this); this maps also properties to observables
                //this.Months = result.ShiftScheduleCalendar.map(v => v.Month).filter( (v, i, a) => a.indexOf(v) === i );
                this.ShiftTypeColors(result.ShiftTypeColors);
            });
    }
    ;
    init() {
        this.DurationHours.subscribe(function (val) {
            if (val < 0) {
                this.DurationHours(0);
            }
            if (val >= 24) {
                this.DurationMinutesEnabled(false);
                this.DurationHours(24);
                this.DurationMinutes(0);
            }
            else if (val == null) {
                this.DurationMinutesEnabled(false);
            }
            else {
                this.DurationMinutesEnabled(true);
            }
        }.bind(this));

        this.DurationMinutes.subscribe(function (val) {
            if (val < 0) {
                this.DurationMinutes(0);
            }
            if (val >= 59) {
                this.DurationMinutes(59);
            }
        }.bind(this));

        this.IsFreeShift.subscribe(function (val) {
            if (val) {
                this.Duration(null);
                this.DurationHours(null);
                this.DurationMinutes(null);
                this.StartTime(null);
            } else {
                this.DurationHours(0);
                this.DurationMinutes(0);
            }
        }.bind(this));

        return $.when(super.init(), this.loadShiftColors())
            .then(() => this.getDuration(this.Duration()));
        //this.ConfigurationItemTypeTab = new TabPage();
        //this.ConfigurationItemTypeTab.Url("ActivityType/ConfigurationItemTypeTab");
        //this.TabController.AddTab(this.ConfigurationItemTypeTab);
    }

    MinimizeEntity() {
        let model: any = super.MinimizeEntity();
        // if checkbox "IsAllowForAutomaticSwapProposal" is unchecked, we have to set SwapPriority to null!
        if (!model.IsAllowForAutomaticSwapProposal) {
            model.SwapPriority = null;
        }
        return model;
    }


    // Convert the db value to hours and minutes
    getDuration(durationString) {
        if (!Bao.Utils.String.IsNullOrWhitespace(durationString)) {
            if (durationString.slice(durationString.length - 1) === "h") {
                let hours = parseInt(durationString.slice(0, -1));
                if (!isNaN(hours)) {
                    this.DurationHours(hours);
                }
            }
            else {
                let minutes = parseInt(durationString);
                if (!isNaN(minutes)) {
                    this.DurationHours(Math.floor(minutes / 60))
                    this.DurationMinutes(minutes % 60)
                }
            }
        }
    }
}
export default ShiftType;